import EitherOrParticipationRequestModel from "./EitherOrParticipationRequestModel";

export default class EitherOrParticipationRequestFullModel extends EitherOrParticipationRequestModel {
  public expired: boolean = false;
  public time: number = 0;
}
